import _ from "lodash";
import { PromiseWrapper } from "../../utils/pw";
import { BaseStore } from "./base";
const compare = (a, b) => {
    const result = {
        different: [],
        missing_from_first: [],
        missing_from_second: [],
    };
    _.reduce(a, (result, value, key) => {
        if (b.hasOwnProperty(key)) {
            if (_.isEqual(value, b[key])) {
                return result;
            }
            else {
                if (typeof a[key] != typeof {} ||
                    typeof b[key] != typeof {}) {
                    result.different.push(key);
                    return result;
                }
                else {
                    const deeper = compare(a[key], b[key]);
                    result.different = result.different.concat(_.map(deeper.different, (sub_path) => {
                        return key + "." + sub_path;
                    }));
                    result.missing_from_second =
                        result.missing_from_second.concat(_.map(deeper.missing_from_second, (sub_path) => {
                            return key + "." + sub_path;
                        }));
                    result.missing_from_first =
                        result.missing_from_first.concat(_.map(deeper.missing_from_first, (sub_path) => {
                            return key + "." + sub_path;
                        }));
                    return result;
                }
            }
        }
        else {
            result.missing_from_second.push(key);
            return result;
        }
    }, result);
    _.reduce(b, function (result, value, key) {
        if (a.hasOwnProperty(key)) {
            return result;
        }
        else {
            result.missing_from_first.push(key);
            return result;
        }
    }, result);
    return result;
};
export class RemoteStore extends BaseStore {
    constructor(glue, params) {
        super(params);
        this.glue = glue;
        this.sharedContextName = `$FINSEMBLE:DS:${params.store}`;
    }
    async setValueCore(params, cb) {
        const path = typeof params === "string" ? params : params.field;
        await this.glue.contexts.setPath(this.sharedContextName, path, params.value);
        this.values = await this.glue.contexts.get(this.sharedContextName);
        if (cb) {
            cb(null);
        }
    }
    async initCore() {
        const pw = new PromiseWrapper();
        await this.glue.contexts.subscribe(this.sharedContextName, (data) => {
            if (!pw.resolved) {
                pw.resolve();
            }
            this.handleUpdate(data);
        });
        try {
            await this.glue.interop.invoke("FSBL.Clients.DistributedStoreClient.init", {
                store: this.sharedContextName,
                value: this.params?.values ?? {}
            }, "best", { waitTimeoutMs: 0 });
        }
        catch (e) {
            await this.glue.contexts.update(this.sharedContextName, this.params?.values ?? {});
        }
        await pw.promise;
    }
    async destroyCore(cb) {
        try {
            const contexts = await this.glue.contexts.all();
            if (contexts.includes(this.sharedContextName)) {
                this.glue.contexts.destroy(this.sharedContextName);
            }
        }
        catch {
        }
        if (cb) {
            cb(null, undefined);
        }
    }
    handleUpdate(data) {
        const diff = compare(this.values, data ?? {});
        const paths = diff.different.concat(diff.missing_from_first).concat(diff.missing_from_second);
        this.values = data;
        paths.forEach((p) => {
            this.notifyListeners(p);
        });
    }
}
